import React from "react";
export default function HCR_Less_Than() {
  return <div>HCR_Less_Than</div>;
}
